import { useEffect } from 'react';

// Import hooks
import { useAppSelector } from 'store/hooks';
import { useSummaryStore } from 'components/views/offer_configurator/hooks/useSummaryStore';

// Import helpers
import { sendPacketsViewEvent } from 'helpers/tracking';

export const useOfferReview = () => {
	const clearSummaryStore = useSummaryStore((state) => state.clearSummaryStore);
	const packets = useAppSelector(({ configurator }) => configurator.packets);

	useEffect(() => {
		clearSummaryStore();
		sendPacketsViewEvent(packets.main.concat(packets.premium));
	}, []);
};
